import { Routes } from '@angular/router';
import { NotFoundComponent } from './common/not-found/not-found.component';
import { AppsComponent } from './apps/apps.component';
import { HomeComponent } from './home/home.component';
import { LandingAccessComponent } from './landing-access/landing-access.component';
import { MainComponent } from './main/main.component';
import { RequestAccessComponent } from './request-access/request-access.component';
import { authGuard } from './services/auth.guard';
import { unsavedChangesGuard } from './services/unsaved-changes.guard';
import { ProfileComponent } from './profile/profile.component';
import { AdminAddUserComponent } from './admin-add-user/admin-add-user.component';
import { EstimatorAppDualComponent } from './apps/estimator-app-dual/estimator-app-dual.component';
import { TrainingComponent } from './apps/training/training.component';
import { AdminViewStatsComponent } from './admin-view-stats/admin-view-stats.component';
import { UserSessionsComponent } from './user-sessions/user-sessions.component';
import { SharedSessionsComponent } from './shared-sessions/shared-sessions.component';
import { UsersComponent } from './users/users.component';


export const routes: Routes = [
    {
        path: '',
        component: LandingAccessComponent,
    },
    {
      path: 'sign-in',
      component: LandingAccessComponent,
    },
    {
      path: 'request-access',
      component: RequestAccessComponent,
    },
    {
      path: 'main',
      component: MainComponent,
      children: [
        {path: '', component: HomeComponent},
        {path: 'apps', component: AppsComponent,
          children: [
            {path: 'estimator-dual-photo', component: EstimatorAppDualComponent, canDeactivate: [unsavedChangesGuard]},
            {path: 'train', component: TrainingComponent, canDeactivate: [unsavedChangesGuard]},
            {path: 'sessions', component: UserSessionsComponent},
            {path: 'shared-sessions', component: SharedSessionsComponent}
          ]
        },
        {path: 'profile', component: ProfileComponent},
        {path: 'users', component: UsersComponent},
        {path: 'add-user', component: AdminAddUserComponent},
        {path: 'stats', component: AdminViewStatsComponent}
    ],
    canActivate: [authGuard]
    },
    {
      path: '**', component: NotFoundComponent, canActivate: [authGuard]
    }
];
